import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';
import { SUBSCRIPTION_HEADER_NAME } from '../constants/constants';
import { API_ROOT } from '../helpers/apiConfig';
import { saveFile } from '../helpers/saveFile';

export const actions = {
    loadTaskCompletionBySection: (subscriptionId, locationKey, sliceIdentifierName) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/task-completion-by',
                    method: 'POST',
                    body: {
                        subscriptionId: subscriptionId,
                        locationKey: locationKey,
                        sliceIdentifierName: sliceIdentifierName
                    },
                    types: [
                        types.LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_REQUEST,
                        types.LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_SUCCESS,
                        types.LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_FAILURE
                    ]
                }
            });
        }
    },
    loadExternalTaskCompletionBySection: (locationKey, userKey, sliceName) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/external-task-completion-by',
                    method: 'POST',
                    body: {
                        locationKey: locationKey,
                        userKey: userKey,
                        sliceIdentifierName: sliceName
                    },
                    types: [
                        types.LOAD_EXTERNAL_TASK_COMPLETION_BY_REQUEST,
                        types.LOAD_EXTERNAL_TASK_COMPLETION_BY_SUCCESS,
                        types.LOAD_EXTERNAL_TASK_COMPLETION_BY_FAILURE
                    ]
                }
            });
        }
    },    
    loadSummary: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/summary',
                    method: 'POST',
                    body: { locationKey: locationKey },
                    types: [
                        types.LOAD_LOCATION_DASHBOARD_SUMMARY_REQUEST,
                        types.LOAD_LOCATION_DASHBOARD_SUMMARY_SUCCESS,
                        types.LOAD_LOCATION_DASHBOARD_SUMMARY_FAILURE
                    ]
                }
            });
        }
    },

    loadFinancialsSummary: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/financials-summary',
                    method: 'POST',
                    body: { locationKey: locationKey },
                    types: [
                        types.LOAD_FINANCIALS_SUMMARY_REQUEST,
                        types.LOAD_FINANCIALS_SUMMARY_SUCCESS,
                        types.LOAD_FINANCIALS_SUMMARY_FAILURE
                    ]
                }
            });
        }
    },
    
    loadLocationGoals: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/location-goals',
                    method: 'POST',
                    body: { locationKey: locationKey },
                    types: [
                        types.LOAD_LOCATION_GOALS_REQUEST,
                        types.LOAD_LOCATION_GOALS_SUCCESS,
                        types.LOAD_LOCATION_GOALS_FAILURE
                    ]
                }
            });
        }
    },    
    saveLocationGoals: (params) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/save-location-goals',
                    method: 'POST',
                    body: params,
                    types: [
                        types.SAVE_LOCATION_GOALS_REQUEST,
                        types.SAVE_LOCATION_GOALS_SUCCESS,
                        types.SAVE_LOCATION_GOALS_FAILURE
                    ]
                }
            });
        }
    },      
    loadDetailsFilters: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/details-filters',
                    method: 'POST',
                    body: { locationKey: locationKey },
                    types: [
                        types.LOAD_LOCATION_DASHBOARD_DETAILS_REQUEST,
                        types.LOAD_LOCATION_DASHBOARD_DETAILS_SUCCESS,
                        types.LOAD_LOCATION_DASHBOARD_DETAILS_FAILURE
                    ]
                }
            });
        }
    },
    updateDetails: (newDetails) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/update-details',
                    method: 'POST',
                    body: newDetails,
                    types: [
                        types.LOCATION_DASHBOARD_UPDATE_DETAILS_REQUEST,
                        types.LOCATION_DASHBOARD_UPDATE_DETAILS_SUCCESS,
                        types.LOCATION_DASHBOARD_UPDATE_DETAILS_FAILURE
                    ]
                }
            });
        }
    },
    loadProjectsByLocationSection: (searchParams) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/projects-by-location',
                    method: 'POST',
                    body: searchParams,
                    types: [
                        types.LOAD_PROJECTS_BY_LOCATION_REQUEST,
                        types.LOAD_PROJECTS_BY_LOCATION_SUCCESS,
                        types.LOAD_PROJECTS_BY_LOCATION_FAILURE
                    ]
                }
            });
        }
    },
    projectsWidgetDrawerFilters: (locationKey, projectId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/projects-widget-drawer-filters',
                    method: 'POST',
                    body: {
                        locationKey: locationKey,
                        projectId: projectId
                    },
                    types: [
                        types.LOAD_PROJECT_WIDGET_DRAWER_FILTERS_REQUEST,
                        types.LOAD_PROJECT_WIDGET_DRAWER_FILTERS_SUCCESS,
                        types.LOAD_PROJECT_WIDGET_DRAWER_FILTERS_FAILURE
                    ]
                }
            });
        }
    }, 
    loadMilestones: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/milestones',
                    method: 'POST',
                    body: {
                        locationKey: locationKey
                    },
                    types: [
                        types.LOAD_MILESTONES_BY_LOCATION_REQUEST,
                        types.LOAD_MILESTONES_BY_LOCATION_SUCCESS,
                        types.LOAD_MILESTONES_BY_LOCATION_FAILURE
                    ]
                }
            });
        }
    },
    loadMilestonesListing: (searchParams) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/milestones-listing',
                    method: 'POST',
                    body: searchParams,
                    types: [
                        types.LOAD_MILESTONES_LISTING_REQUEST,
                        types.LOAD_MILESTONES_LISTING_SUCCESS,
                        types.LOAD_MILESTONES_LISTING_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationFiles: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/load-files/' + locationKey,
                    method: 'GET',
                    types: [
                        types.LOAD_LOCATION_DASHBOARD_FILES_REQUEST,
                        types.LOAD_LOCATION_DASHBOARD_FILES_SUCCESS,
                        types.LOAD_LOCATION_DASHBOARD_FILES_FAILURE
                    ]
                }
            });
        }
    },
    getTaskAssignmentCounts: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/task-assignment-counts/' + locationKey,
                    method: 'GET',
                    types: [
                        types.LOAD_TASK_ASSIGNMENT_COUNTS_REQUEST,
                        types.LOAD_TASK_ASSIGNMENT_COUNTS_SUCCESS,
                        types.LOAD_TASK_ASSIGNMENT_COUNTS_FAILURE
                    ]
                }
            });
        }
    },
    getTaskAssignmentFilters: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/task-assignment-filters/' + locationKey,
                    method: 'GET',
                    types: [
                        types.LOAD_TASK_ASSIGNMENT_FILTERS_REQUEST,
                        types.LOAD_TASK_ASSIGNMENT_FILTERS_SUCCESS,
                        types.LOAD_TASK_ASSIGNMENT_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    saveTaskAssignments: (locationKey, assignments) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/save-task-assignments',
                    method: 'POST',
                    body: {
                        locationKey: locationKey,
                        assignments: assignments
                    },
                    types: [
                        types.SAVE_TASK_ASSIGNMENTS_REQUEST,
                        types.SAVE_TASK_ASSIGNMENTS_SUCCESS,
                        types.SAVE_TASK_ASSIGNMENTS_FAILURE
                    ]
                }
            });
        }
    },
    getTaskReassignments: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/task-reassignments/' + locationKey,
                    method: 'GET',
                    types: [
                        types.LOAD_TASK_REASSIGNMENTS_REQUEST,
                        types.LOAD_TASK_REASSIGNMENTS_SUCCESS,
                        types.LOAD_TASK_REASSIGNMENTS_FAILURE
                    ]
                }
            });
        }
    },

    loadFinancialsSpreadsheet: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/financials-spreadsheet',
                    method: 'POST',
                    body: { locationKey: locationKey },
                    types: [
                        types.LOAD_LOCATION_FINANCIALS_SPREADSHEET_REQUEST,
                        types.LOAD_LOCATION_FINANCIALS_SPREADSHEET_SUCCESS,
                        types.LOAD_LOCATION_FINANCIALS_SPREADSHEET_FAILURE
                    ]
                }
            });
        }
    },

    // need correct parameters
    saveFinancialsSpreadsheet: (taskArray) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/save-financials-spreadsheet',
                    method: 'POST',
                    body: { updatedLocationTasks : taskArray },
                    types: [
                        types.SAVE_LOCATION_FINANCIALS_SPREADSHEET_REQUEST,
                        types.SAVE_LOCATION_FINANCIALS_SPREADSHEET_SUCCESS,
                        types.SAVE_LOCATION_FINANCIALS_SPREADSHEET_FAILURE
                    ]
                }
            });
        }
    },

    loadSingleProjectDrawerFilters: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/single-project-drawer-filters',
                    method: 'GET',
                    types: [
                        types.LOAD_SINGLE_PROJECT_DRAWER_FILTERS_REQUEST,
                        types.LOAD_SINGLE_PROJECT_DRAWER_FILTERS_SUCCESS,
                        types.LOAD_SINGLE_PROJECT_DRAWER_FILTERS_FAILURE
                    ]
                }
            });
        }
    },

    createSingleLocationProject: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-dashboard/create-single-location-project',
                    method: 'POST',
                    body: request,
                    types: [
                        types.CREATE_SINGLE_LOCATION_PROJECT_REQUEST,
                        types.CREATE_SINGLE_LOCATION_PROJECT_SUCCESS,
                        types.CREATE_SINGLE_LOCATION_PROJECT_FAILURE
                    ]
                }
            });
        }
    },

    getUnassignedTasksForProjectCoaches: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'company-dashboard/unassigned-tasks-project-coaches/' + locationKey,
                    method: 'GET',
                    types: [
                        types.DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_REQUEST,
                        types.DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_SUCCESS,
                        types.DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_FAILURE
                    ]
                }
            });
        }
    },

    exportHistoricalProjects: (locationKey) => {
        return (dispatch, getState) => {
            const endpoint = 'location-dashboard/historical-projects';
            const method = 'POST';
            let headers = { "Content-Type": "application/json" };
            const token = getState().user.accessToken;
            if (typeof token === "string") {
                headers.Authorization = `Bearer ${token}`;
            }
            const subscriptionId = getState().user.currentSubscriptionId;
            if (subscriptionId) {
                headers[SUBSCRIPTION_HEADER_NAME] = subscriptionId;
            }

            const body = {
                locationKey
            };

            return (
                // eslint-disable-next-line no-undef
                fetch(`${API_ROOT}${endpoint}`, {
                    method,
                    headers,
                    body: JSON.stringify(body),
                    credentials: "same-origin"
                })
                    .then(async response => {
                        await saveFile(response);
                    })
            );
        }
    },

}
